// extracted by mini-css-extract-plugin
module.exports = {"label":"FormLabel_label__A3aJr","errorLabel":"FormLabel_errorLabel__22D1i"};